import React from "react"

import { Text } from "@/components/Text"

import { TitleProps } from "@/components/Dialog/protocols"
import { Grid2 } from "@mui/material"

export const Title = ({ children }: TitleProps) => {
	return (
		<Grid2
			size={11}
		>
			<Text.Title
				type="h2"
				fontWeight="semibold"
			>
				{children}
			</Text.Title>
		</Grid2>
	)
}